import { Path } from 'react-hook-form';

import { InbodyDataField } from '../../../../../../../shared/constants/inbody-info/inbodyData';
import { EntityInbodyDataFormValue } from '../../../../EntityInbodyDataConfig.settings';

export const getFieldFormName = (
  field: InbodyDataField,
): Path<EntityInbodyDataFormValue> => `nonInbodyData.${field}`;
